"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.choice_present = exports.present = void 0;
const Exp = __importStar(require("../exp"));
const Value = __importStar(require("../value"));
const DEFAULT_PRESENT_OPTS = {
    on_grammar: "as_exp",
};
function present(value, opts = DEFAULT_PRESENT_OPTS) {
    switch (value.kind) {
        case "Value.fn": {
            const { ret_cl: { name, exp }, } = value;
            return { $fn: [name, Exp.present(exp)] };
        }
        case "Value.str": {
            return JSON.stringify(value.value);
        }
        case "Value.pattern": {
            return value.value.flags
                ? { $pattern: [value.label, value.value.source, value.value.flags] }
                : { $pattern: [value.label, value.value.source] };
        }
        case "Value.grammar": {
            const { name, delayed } = value;
            switch (opts.on_grammar) {
                case "force_one_step": {
                    const result = {};
                    for (const [choice_name, parts] of Value.DelayedChoices.force(delayed)) {
                        Object.assign(result, Value.choice_present(name, choice_name, parts));
                    }
                    return result;
                }
                case "as_exp": {
                    const result = {};
                    for (const [choice_name, parts] of delayed.choices) {
                        Object.assign(result, Exp.choice_present(name, choice_name, parts));
                    }
                    return result;
                }
                case "only_show_name": {
                    return name;
                }
            }
        }
    }
}
exports.present = present;
function choice_present(grammar_name, choice_name, parts) {
    return {
        [`${grammar_name}:${choice_name}`]: parts.map((part) => {
            const { name, value } = part;
            return name
                ? { [name]: present(value, { on_grammar: "only_show_name" }) }
                : present(value, { on_grammar: "only_show_name" });
        }),
    };
}
exports.choice_present = choice_present;
//# sourceMappingURL=value-present.js.map